import React from "react";

const ProductoHeaderMod = ({ producto, ubicacion, estado }) => {
	var titulo = "";
	var descripcion = "";
	var img = "";

	if (ubicacion === "home") {
		titulo = producto.rubro_nombre + " " + producto.nombre;
		descripcion = producto.descripcion;
		img = producto.img;
	} else if (ubicacion === "lista") {
		titulo = producto.rubro.nombre + " " + producto.nombre;
		descripcion = producto.descripcion;
		img = producto.img;
	} else if (ubicacion === "producto") {
		titulo = producto.rubro.nombre + " " + producto.categoria.nombre;
		descripcion = producto.cat_desc;
		img = producto.cat_img;
	}

	return (
		<div className={"carousel-item row p-3 p-md-5  " + estado}>
			<div className="d-flex flex-row justify-content-center">
				<div className="headerMod">
					<div className="headData col-12  col-md-6">
						<h1 className="hero-title">{titulo}</h1>
						<p className="hero-text">{descripcion}</p>
					</div>
					<img className="headImg col-12 col-md-6" src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F" + img + "?alt=media"} alt={titulo} />
				</div>
			</div>
		</div>
	);
};

export default ProductoHeaderMod;



// WEBPACK FOOTER //
// ./src/components/productos_header_mod.js